import React from 'react';
import { FormattedMessage } from 'react-intl';
import Contact1stdibsFooterLink from '../../Contact1stdibsLink/Contact1stdibsFooterLink';

export default [
    {
        trackingLabel: 'About Us',
        enablerKey: 'isAboutUsPageEnabled',
        href: '/about/',
        dataTn: 'footer-about-us',
        message: <FormattedMessage id="dbl.Footer.site_links_about_us" defaultMessage="About Us" />,
    },
    {
        trackingLabel: 'Contact 1stDibs',
        dataTn: 'footer-contact-1stdibs',
        CustomComponent: Contact1stdibsFooterLink,
    },
    {
        trackingLabel: 'Support Center',
        href: 'https://support.1stdibs.com/',
        target: '_blank',
        dataTn: 'footer-support',
        message: (
            <FormattedMessage id="dbl.Footer.site_links_support" defaultMessage="Support Center" />
        ),
    },
    {
        trackingLabel: 'Press',
        enablerKey: 'isPressPageEnabled',
        href: '/about/press/',
        dataTn: 'footer-press',
        message: <FormattedMessage id="dbl.Footer.site_links_press" defaultMessage="Press" />,
    },
    {
        trackingLabel: 'Careers',
        enablerKey: 'isCareersPageEnabled',
        href: '/about/careers/',
        dataTn: 'footer-jobs',
        message: <FormattedMessage id="dbl.Footer.site_links_jobs" defaultMessage="Careers" />,
    },
];
